import { render, staticRenderFns } from "./FieldProperties.vue?vue&type=template&id=423b9695&scoped=true"
import script from "./FieldProperties.vue?vue&type=script&lang=js"
export * from "./FieldProperties.vue?vue&type=script&lang=js"
import style0 from "./FieldProperties.vue?vue&type=style&index=0&id=423b9695&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "423b9695",
  null
  
)

export default component.exports